import Controller from "./bulkcredits.controller";
import template from "./bulkcredits.html";

const bulkcredits = {
  template,
  controller: Controller,
};

export default bulkcredits;



// WEBPACK FOOTER //
// ./src/pages/bulkcredits/bulkcredits.component.js